import {uploadRetribuzioniApi} from "@commons/features/PVA/uploadRetribuzioni.api";

export const serviziReducers = {
    [uploadRetribuzioniApi.reducerPath]: uploadRetribuzioniApi.reducer,
}
export const serviziMiddlewares = [
    uploadRetribuzioniApi.middleware,
]